import { jsxs, jsx } from 'react/jsx-runtime';

const RadioButton = ({ checked, onChange, ...props }) => {
    return (jsxs("label", { className: "relative flex items-center cursor-pointer shrink-0 mt-0.5", children: [jsx("input", { type: "radio", checked: checked, onChange: onChange, role: "radio", className: "peer sr-only", ...props }), jsx("span", { className: `h-5 w-5 rounded-full border-2 flex items-center justify-center transition-colors ${checked ? 'border-black' : 'border-neutral-400'}`, children: checked && jsx("span", { className: `h-2.5 w-2.5 rounded-full bg-input-icon-selected` }) })] }));
};

export { RadioButton };
